<template>
  <div class="row mb-3 align-items-center wrapper_input select" :class="wrapperClass">
    <label v-if="label" class="col-sm-6 col-form-label select" v-html="label" />
    <div class="col-sm row mx-0 align-items-center">
      <select
        class="form-select col select"
        :value="modelValue"
        @change="onChange"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >{{ option.label }}</option>
      </select>
      <div v-if="$slots.hint" class="col-auto p-0">
        <slot name="hint" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends string | number">
export interface SelectOption<V> {
  label: string
  value: V
}

withDefaults(
  defineProps<{
    modelValue?: T | ''
    label?: string
    options: SelectOption<T>[]
    hint?: string
    wrapperClass?: string
  }>(),
  { modelValue: '', label: '', hint: '', wrapperClass: '' },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

function onChange(event: Event): void {
  const target = event.target as HTMLSelectElement
  emit('update:modelValue', target.value)
}
</script>
